import styled from 'styled-components';

const Label = styled.label`
  display: flex;
  align-items: flex-start;
  padding: 0;
  margin: 2rem 0;
`;

export default Label;
